import { render, staticRenderFns } from "./indexDataBoard.vue?vue&type=template&id=4ad4372a&"
import script from "./indexDataBoard.vue?vue&type=script&lang=js&"
export * from "./indexDataBoard.vue?vue&type=script&lang=js&"
import style0 from "./indexDataBoard.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports